(()=>{
  const numberFromSrc=src=>{const m=String(src||"").match(/flotta-(\d{2})\.jpg/i);return m?Number(m[1]):null;};
  const RATES={1:60,2:60,3:60,4:60,5:60,6:60,7:80,8:60,9:60,10:60,12:60,13:60,14:60,15:80,16:60,17:60,18:60,19:60};
  const KNOWN_CATEGORY={7:"Centinato ~4,10 m"};
  const form=document.querySelector("#km-calculator .kmcalc-form");
  if(!form)return;

  const style=document.createElement("style");
  style.id="guided-rental-styles";
  style.textContent=`
    .guided-progress{display:grid;grid-template-columns:repeat(5,1fr);gap:7px;margin:0 0 16px}
    .guided-progress span{display:flex;align-items:center;gap:7px;min-height:42px;padding:8px 10px;border-radius:12px;background:#f1f3f3;color:#6d7477;font-size:10px;font-weight:900;line-height:1.15;text-transform:uppercase;letter-spacing:.04em}
    .guided-progress b{display:inline-flex;align-items:center;justify-content:center;min-width:22px;height:22px;border-radius:999px;background:#d9ddde;color:#111;font-size:10px}
    .guided-progress span.active{background:#111;color:#fff}.guided-progress span.active b{background:#fff;color:#111}
    .guided-progress span.done{background:#e9f8ee;color:#14773a}.guided-progress span.done b{background:#20b858;color:#fff}
    .guided-step{border:1px solid #e1e4e5;border-radius:18px;padding:16px;margin:0 0 12px;background:#fff;transition:.18s ease}
    .guided-step.active{border-color:#111;box-shadow:0 7px 24px rgba(0,0,0,.07)}
    .guided-step.done{border-color:#bee5ca}
    .guided-step-head{display:flex;align-items:center;gap:10px;margin:0 0 13px}
    .guided-step-num{display:inline-flex;align-items:center;justify-content:center;width:30px;height:30px;border-radius:999px;background:#111;color:#fff;font-size:11px;font-weight:950}
    .guided-step-head strong{font-size:15px}.guided-step-head small{display:block;color:#777;font-size:11px;margin-top:1px}
    .vehicle-pref-label::after{content:" · FACOLTATIVO";font-size:9px;color:#777;letter-spacing:.06em}
    .vehicle-filter-note{font-size:11px;color:#71797c;margin:-4px 2px 10px;line-height:1.35}
    .sticky-vehicle-summary{display:none;position:sticky;top:78px;z-index:35;border-radius:18px;background:#111;color:#fff;padding:12px;margin:0 0 12px;box-shadow:0 14px 36px rgba(0,0,0,.18);grid-template-columns:82px 1fr auto;gap:12px;align-items:center}
    .sticky-vehicle-summary.show{display:grid}.sticky-vehicle-summary img{width:82px;height:62px;object-fit:cover;border-radius:12px;background:#333}
    .sticky-vehicle-summary span{display:block;font-size:10px;text-transform:uppercase;letter-spacing:.06em;color:#bfc5c7;font-weight:900}.sticky-vehicle-summary strong{display:block;font-size:16px;margin-top:2px}.sticky-vehicle-summary small{display:block;color:#d6dbdc;font-size:11px;margin-top:2px}
    .availability-badge{display:inline-flex!important;align-items:center!important;justify-content:center!important;min-height:28px!important;padding:5px 9px!important;border-radius:999px!important;background:#eef0f0!important;color:#555!important;font-size:9px!important;font-weight:950!important;letter-spacing:.04em!important;text-transform:uppercase!important;white-space:nowrap!important}
    .availability-badge.available{background:#e5f8eb!important;color:#117536!important}.availability-badge.unavailable{background:#fdeaea!important;color:#a02323!important}
    .vehicle-option.is-unavailable{opacity:.48}.vehicle-option.is-unavailable::after{content:"Non disponibile";font-size:9px;font-weight:950;color:#a02323}
    .vehicle-option .availability-badge{grid-column:2/4;justify-self:start;margin-top:-4px}
    .final-rental-summary{display:none;border:2px solid #111;border-radius:18px;padding:16px;margin:10px 0;background:#fafafa}.final-rental-summary.show{display:block}
    .final-rental-summary .final-label{font-size:10px;text-transform:uppercase;letter-spacing:.08em;color:#747b7d;font-weight:950}.final-rental-summary .final-main{font-size:19px;font-weight:950;line-height:1.25;margin:5px 0}.final-rental-summary .final-sub{font-size:12px;color:#5f686b;line-height:1.4}.final-rental-summary .availability-badge{margin-top:10px}
    #km-wa-btn{min-height:58px;font-size:13px;font-weight:950;justify-content:center;text-align:center}
    #rental-days{font-weight:950}
    .guided-step .vehicle-pref-wrap,.guided-step .vehicle-picker,.guided-step .kmcalc-field,.guided-step .kmcalc-fields,.guided-step .kmcalc-dayline{margin-bottom:10px}
    @media(max-width:720px){
      .guided-progress{grid-template-columns:repeat(5,minmax(50px,1fr));overflow-x:auto;padding-bottom:3px}.guided-progress span{min-width:67px;justify-content:center;text-align:center;padding:7px 5px}.guided-progress span i{display:none}
      .sticky-vehicle-summary{position:static;grid-template-columns:70px 1fr}.sticky-vehicle-summary img{width:70px;height:54px}.sticky-vehicle-summary>.availability-badge{grid-column:1/3;justify-self:start}
      .guided-step{padding:14px}
    }
  `;
  document.head.appendChild(style);

  const normalize150=()=>{
    const walker=document.createTreeWalker(document.body,NodeFilter.SHOW_TEXT);
    const nodes=[];let node;while(node=walker.nextNode())nodes.push(node);
    nodes.forEach(n=>{
      let t=n.nodeValue||"";
      t=t.replace(/150\s*km\s+inclusi\s+per\s+giorno/gi,"150 km inclusi al giorno");
      t=t.replace(/150\s*km\s+inclusi(?!\s+al\s+giorno)/gi,"150 km inclusi al giorno");
      if(t!==n.nodeValue)n.nodeValue=t;
    });
  };
  normalize150();

  const sortByNumber=selector=>{
    const items=[...document.querySelectorAll(selector)];
    if(!items.length)return;
    items.forEach(item=>{const n=numberFromSrc(item.querySelector("img")?.currentSrc||item.querySelector("img")?.src);if(n)item.dataset.vehicleNumber=String(n);});
    const parent=items[0].parentElement;
    items.sort((a,b)=>Number(a.dataset.vehicleNumber||0)-Number(b.dataset.vehicleNumber||0)).forEach(item=>parent?.appendChild(item));
  };
  sortByNumber(".fleet .card");
  sortByNumber(".gallery .gallery-item");
  sortByNumber(".vehicle-picker-menu .vehicle-option");
  const pickerSubtitle=document.querySelector(".vehicle-picker-subtitle");
  if(pickerSubtitle)pickerSubtitle.textContent="18 furgoni della flotta con fotografie";

  const typeWrap=form.querySelector(".vehicle-pref-wrap");
  const typeSelect=document.getElementById("vehicle-type-pref");
  const picker=document.getElementById("vehicle-exact-picker");
  const datesWrap=pickupParent()?.parentElement||form.querySelector(".kmcalc-fields");
  function pickupParent(){return document.getElementById("pickup-date")?.closest(".kmcalc-field")||null;}
  const dayline=form.querySelector(".kmcalc-dayline");
  const kmField=document.getElementById("km-input")?.closest(".kmcalc-field");
  const calcButton=document.getElementById("km-calc-btn");
  const result=form.querySelector(".kmcalc-result");
  const waButton=document.getElementById("km-wa-btn");
  const status=document.getElementById("km-status");
  const pickup=document.getElementById("pickup-date");
  const ret=document.getElementById("return-date");
  const kmInput=document.getElementById("km-input");
  const totalEl=document.getElementById("km-total");
  const daysEl=document.getElementById("rental-days");

  if(typeWrap){
    const label=typeWrap.querySelector(".vehicle-pref-label");if(label)label.textContent="Filtro dimensione";
    if(typeSelect?.options?.[0])typeSelect.options[0].textContent="Mostra tutti / non so quale scegliere";
    if(!typeWrap.querySelector(".vehicle-filter-note")){
      const note=document.createElement("div");note.className="vehicle-filter-note";note.textContent="Facoltativo: serve a restringere la scelta. La misura esatta del singolo mezzo viene sempre confermata prima del noleggio.";typeWrap.appendChild(note);
    }
  }

  const progress=document.createElement("div");
  progress.className="guided-progress";
  progress.innerHTML=`<span data-p="1" class="active"><b>1</b><i>Date</i></span><span data-p="2"><b>2</b><i>Furgone</i></span><span data-p="3"><b>3</b><i>Km</i></span><span data-p="4"><b>4</b><i>Prezzo</i></span><span data-p="5"><b>5</b><i>Disponibilità</i></span>`;
  form.insertBefore(progress,form.firstChild);

  const makeStep=(n,title,sub)=>{const el=document.createElement("section");el.className="guided-step";el.dataset.step=String(n);el.innerHTML=`<div class="guided-step-head"><span class="guided-step-num">${n}</span><div><strong>${title}</strong><small>${sub}</small></div></div>`;return el;};
  const step1=makeStep(1,"Scegli le date","Ritiro e riconsegna");
  const step2=makeStep(2,"Scegli il furgone","Filtro facoltativo + foto del mezzo");
  const step3=makeStep(3,"Indica i chilometri","150 km inclusi al giorno");
  const step4=makeStep(4,"Calcola il prezzo","Tariffa applicata automaticamente dal mezzo");
  const step5=makeStep(5,"Verifica la disponibilità","Riepilogo e WhatsApp");
  [step1,step2,step3,step4,step5].forEach(s=>form.appendChild(s));
  if(datesWrap)step1.appendChild(datesWrap);if(dayline)step1.appendChild(dayline);
  if(typeWrap)step2.appendChild(typeWrap);if(picker)step2.appendChild(picker);
  if(kmField)step3.appendChild(kmField);
  if(calcButton)step4.appendChild(calcButton);if(result)step4.appendChild(result);

  const sticky=document.createElement("div");sticky.className="sticky-vehicle-summary";sticky.innerHTML=`<img alt="Furgone selezionato"><div><span>Selezione attuale</span><strong>—</strong><small>—</small></div><span class="availability-badge">Disponibilità da verificare</span>`;
  form.insertBefore(sticky,step1);
  const finalSummary=document.createElement("div");finalSummary.className="final-rental-summary";finalSummary.innerHTML=`<div class="final-label">Riepilogo preventivo</div><div class="final-main">—</div><div class="final-sub">—</div><span class="availability-badge">Disponibilità da verificare</span>`;
  step5.appendChild(finalSummary);if(waButton)step5.appendChild(waButton);if(status)step5.appendChild(status);
  if(waButton)waButton.textContent="VERIFICA DISPONIBILITÀ PER QUESTE DATE";

  const dateInfo=()=>{
    if(!pickup?.value||!ret?.value)return null;
    const [sy,sm,sd]=pickup.value.split("-").map(Number),[ey,em,ed]=ret.value.split("-").map(Number);
    const start=Date.UTC(sy,sm-1,sd),end=Date.UTC(ey,em-1,ed);
    if(!Number.isFinite(start)||!Number.isFinite(end)||end<start)return null;
    return {days:Math.floor((end-start)/86400000)+1,pickup:pickup.value,ret:ret.value};
  };
  const fmtDate=value=>{if(!value)return"—";const [y,m,d]=value.split("-");return `${d}/${m}/${y}`;};
  const selectedVehicle=()=>{
    const title=document.querySelector(".vehicle-picker-title")?.textContent||"";
    const m=title.match(/N\.?\s*(\d+)/i);if(!m)return null;
    const n=Number(m[1]);
    const img=document.querySelector(".vehicle-preview.show img")?.src||document.querySelector(`.vehicle-option img[alt="Furgone N.${n}"]`)?.src||"";
    return {n,rate:RATES[n]||null,img};
  };
  const validKm=()=>{const km=Math.ceil(Number(kmInput?.value));return Number.isFinite(km)&&km>0?km:null;};
  const validTotal=()=>{const t=(totalEl?.textContent||"").trim();return t&&t!=="—"?t:null;};

  const setDaysCopy=()=>{const info=dateInfo();if(daysEl&&info)daysEl.textContent=`${info.days} ${info.days===1?"giorno":"giorni"} di noleggio · 150 km inclusi al giorno`;return info;};

  const availability=new Map();
  const availabilityText=v=>v===true?"Disponibile":v===false?"Non disponibile":"Disponibilità da verificare";
  const availabilityClass=v=>v===true?"available":v===false?"unavailable":"";
  const refreshAvailabilityUI=()=>{
    document.querySelectorAll(".vehicle-option").forEach(option=>{
      const n=numberFromSrc(option.querySelector("img")?.src);if(!n)return;
      let badge=option.querySelector(".availability-badge");if(!badge){badge=document.createElement("span");badge.className="availability-badge";option.appendChild(badge);}
      const v=availability.has(n)?availability.get(n):null;badge.textContent=availabilityText(v);badge.className=`availability-badge ${availabilityClass(v)}`.trim();option.classList.toggle("is-unavailable",v===false);
    });
    const v=selectedVehicle();const state=v&&availability.has(v.n)?availability.get(v.n):null;
    [sticky.querySelector(".availability-badge"),finalSummary.querySelector(".availability-badge")].forEach(b=>{if(!b)return;b.textContent=availabilityText(state);b.className=`availability-badge ${availabilityClass(state)}`.trim();});
  };
  window.MASSAGOMME_SET_AVAILABILITY=map=>{
    if(!map||typeof map!=="object")return;
    Object.entries(map).forEach(([k,v])=>{const n=Number(k);if(n>=1&&n<=19)availability.set(n,v===true||v==="available"?true:v===false||v==="unavailable"?false:null);});
    refreshAvailabilityUI();updateUI();
  };
  const requestAvailability=async()=>{
    const info=dateInfo();availability.clear();refreshAvailabilityUI();if(!info)return;
    document.dispatchEvent(new CustomEvent("massagomme:availability:request",{detail:{pickup:info.pickup,returnDate:info.ret}}));
    if(typeof window.MASSAGOMME_RENTHUB_CHECK==="function"){
      try{const map=await window.MASSAGOMME_RENTHUB_CHECK({pickup:info.pickup,returnDate:info.ret});window.MASSAGOMME_SET_AVAILABILITY(map);}catch(e){console.warn("RentHub availability check unavailable",e);}
    }
  };

  const applyFilter=()=>{
    const filter=typeSelect?.value||"";
    document.querySelectorAll(".vehicle-option").forEach(option=>{
      const n=numberFromSrc(option.querySelector("img")?.src);if(!n)return;
      const known=KNOWN_CATEGORY[n]||"";
      let show=true;
      if(filter==="Centinato ~4,10 m")show=known===filter;
      else if(filter)show=known!=="Centinato ~4,10 m";
      option.style.display=show?"":"none";
    });
    const subtitle=document.querySelector(".vehicle-picker-subtitle");
    if(subtitle)subtitle.textContent=filter?`Filtro: ${filter} · mezzi in ordine N.1 → N.19`:"18 furgoni della flotta con fotografie";
    updateUI();
  };

  const updateSticky=()=>{
    const v=selectedVehicle(),info=setDaysCopy();
    if(!v){sticky.classList.remove("show");return;}
    sticky.classList.add("show");sticky.querySelector("img").src=v.img||"";sticky.querySelector("strong").textContent=`Furgone N.${v.n} · ${v.rate||"—"} € / giorno`;
    sticky.querySelector("small").textContent=info?`${fmtDate(info.pickup)} → ${fmtDate(info.ret)} · ${info.days} ${info.days===1?"giorno":"giorni"}`:"Scegli le date per completare il riepilogo";
    refreshAvailabilityUI();
  };
  const updateFinal=()=>{
    const v=selectedVehicle(),info=dateInfo(),km=validKm(),total=validTotal();
    if(!v||!info||!km||!total){finalSummary.classList.remove("show");return;}
    finalSummary.classList.add("show");
    finalSummary.querySelector(".final-main").textContent=`Furgone N.${v.n} · ${info.days} ${info.days===1?"giorno":"giorni"} · ${km} km · Totale ${total}`;
    finalSummary.querySelector(".final-sub").textContent=`${fmtDate(info.pickup)} → ${fmtDate(info.ret)} · ${v.rate} € / giorno · 150 km inclusi al giorno`;
    refreshAvailabilityUI();
  };
  const updateProgress=()=>{
    const d=!!dateInfo(),v=!!selectedVehicle(),k=!!validKm(),t=!!validTotal();
    const done=[d,d&&v,d&&v&&k,t,false];
    let active=!d?1:!v?2:!k?3:!t?4:5;
    progress.querySelectorAll("span[data-p]").forEach(el=>{const n=Number(el.dataset.p);el.classList.toggle("done",done[n-1]);el.classList.toggle("active",n===active);});
    [step1,step2,step3,step4,step5].forEach((el,i)=>{el.classList.toggle("done",done[i]);el.classList.toggle("active",i+1===active);});
  };
  function updateUI(){normalize150();updateSticky();updateFinal();updateProgress();}

  if(pickup&&ret){
    const syncDates=()=>{
      if(pickup.value){ret.min=pickup.value;if(!ret.value||ret.value<pickup.value){ret.value=pickup.value;ret.dispatchEvent(new Event("change",{bubbles:true}));}}
      setTimeout(()=>{setDaysCopy();updateUI();requestAvailability();},0);
    };
    pickup.addEventListener("change",syncDates);
    ret.addEventListener("change",()=>setTimeout(()=>{setDaysCopy();updateUI();requestAvailability();},0));
  }
  typeSelect?.addEventListener("change",applyFilter);
  document.addEventListener("click",e=>{if(e.target.closest?.(".size-guide-cta"))setTimeout(applyFilter,0);},true);
  document.querySelectorAll(".vehicle-option").forEach(option=>option.addEventListener("click",()=>setTimeout(updateUI,0)));
  kmInput?.addEventListener("input",updateUI);
  calcButton?.addEventListener("click",()=>setTimeout(()=>{updateUI();if(validTotal())step5.scrollIntoView({behavior:"smooth",block:"nearest"});},20));
  const observer=new MutationObserver(()=>updateUI());
  if(totalEl)observer.observe(totalEl,{childList:true,subtree:true,characterData:true});
  const pickerTitle=document.querySelector(".vehicle-picker-title");if(pickerTitle)observer.observe(pickerTitle,{childList:true,subtree:true,characterData:true});

  refreshAvailabilityUI();applyFilter();updateUI();
})();